const initialState = {
  isNewUser: false,
  userId: null,
  userId2: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "SET_USER":
      return { ...state, ...action.payload };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/reducer/user.reducer.js